import { tns } from '../translationNamespace'
import { Exposure } from '@unreserved-frontend-v2/api/generated/graphql/types'

// TODO: Delete when refactoring Admin for schema changes...
export const EXPOSURE = [
  { label: tns + ':east', value: Exposure.East },
  { label: tns + ':north', value: Exposure.North },
  { label: tns + ':northeast', value: Exposure.Northeast },
  { label: tns + ':northwest', value: Exposure.Northwest },
  { label: tns + ':south', value: Exposure.South },
  { label: tns + ':southeast', value: Exposure.Southeast },
  { label: tns + ':southwest', value: Exposure.Southwest },
  { label: tns + ':west', value: Exposure.West },
]

export const EXPOSURE_LABELS: Record<Exposure, string> = EXPOSURE.reduce(
  (memo, item) => ({ ...memo, [item.value]: item.label }),
  {} as Record<Exposure, string>
)
